import React, { Component } from "react";
import Select from "react-select";

import "./DropState.css";

class DropState extends Component {
  render() {
    const {
      selected_state,
      states,
      stateJurisdiction,
      handleStateListChange,
      handleJurisdictionListChange,
      selectedjurisdiction,
      planTypeFilterData,
      handlePlanTypeChange,
      planType,
    } = this.props;

    const planTypeOptions = planTypeFilterData.map((item) => {
      return {
        value: item.id,
        label: item.planType,
      };
    });
    const selectedPlanType = planType
      ? planTypeOptions.find((item) => item.label === planType)
      : null;

    const stateListDisplay = states.map((item) => {
      return {
        value: item.id,
        label: item.stateName,
      };
    });
    const selectedValuestate = selected_state
      ? stateListDisplay.find((item) => item.label === selected_state)
      : null;

    const jurisdictionListDisplay = stateJurisdiction.map((item) => {
      return {
        value: item.id,
        label: item.jurisdictionName,
      };
    });
    const selectedValue = selectedjurisdiction
      ? jurisdictionListDisplay.find(
          (item) => item.label === selectedjurisdiction
        )
      : null;

    return (
      <React.Fragment>
        <div className="dd-wrapper styl-wrapper">
          <Select
            className="font-styl"
            value={selectedValuestate}
            placeholder="State"
            options={stateListDisplay}
            onChange={handleStateListChange}
          />
        </div>
        <div className="dd-wrapper styl-wrapper">
          <Select
            value={selectedValue || null}
            placeholder="Jurisdiction"
            options={jurisdictionListDisplay}
            onChange={handleJurisdictionListChange}
          />
        </div>
        <div className="dd-wrapper styl-wrapper">
          <Select
            value={selectedPlanType || null}
            placeholder="Plan Type"
            options={planTypeOptions}
            onChange={handlePlanTypeChange}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default DropState;
